<template>
  <div class="mb-3">
    <div class="mb-3">
      <div v-for="(group, index) in activeGroups" class="spnod-admin__account--block mb-1" :key="index">
        {{ group.name }} <button class="text-danger" @click="$emit('handleRemove', group)">X</button>
      </div>
    </div>
    <div class="d-flex">
      <b-button class="spnod-admin__form--button mr-2" size="sm" @click="handleAdd">Add</b-button>
      <b-form-select
        class="form-control py-1 flex-grow-1"
        size="sm"
        v-model="newGroup"
      >
        <option :key="0" :value="null">Add to existing Group</option>
        <option v-for="(group, index) in groups" :key="index + 1" :value="group">
          {{ group.name }}
        </option>
      </b-form-select>
    </div>
  </div>
</template>

<script>

export default {
  name: 'UserAccountGroupForm',
  props: ['activeGroups', 'groups'],
  data() {
    return {
      newGroup: null
    }
  },
  methods: {
    handleAdd() {
      this.$emit('handleAdd', this.newGroup)
      this.newGroup = null
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/app/components/UserAccount/UserAccountGroupForm.vue?68b63b74